import React, { useContext, useState } from "react";

import { Content } from "../layout/CommonContentContextProvider.js";
import { useHistory, useLocation } from "react-router";
import { gaSearchQuerySubmit } from "../../helpers/googleAnalytics.js";
import {
    searchLabel,
    searchSubmitButton,
    searchForm,
    searchInput,
} from "./SearchForm.css.js";
import Icon from "../svg/Icon.js";

interface Props {
    q?: string;
}

const SearchForm: React.FC<Props> = ({ q = "" }) => {
    const {
        langCode,
        searchPage: { inputPlaceholder },
    } = useContext(Content);
    const { push } = useHistory();
    const { pathname } = useLocation();

    const [searchValue, setSearchValue] = useState(q);

    const onSubmit: React.FormEventHandler<HTMLFormElement> = e => {
        e.preventDefault();
        gaSearchQuerySubmit(searchValue, langCode, pathname);
        push(`/${langCode}/search?q=${searchValue}`);
    };

    const id = "search-input";

    return (
        <form
            className={searchForm}
            onSubmit={onSubmit}
            action={`/${langCode}/search`}
        >
            <label className={searchLabel} htmlFor={id}>
                <Icon k="search" />
            </label>
            <input
                className={searchInput}
                autoFocus
                id={id}
                type="text"
                name="q"
                autoComplete="off"
                placeholder={inputPlaceholder}
                value={searchValue}
                onChange={e => setSearchValue(e.target.value)}
                required
            />
            <button
                className={searchSubmitButton}
                type="submit"
                disabled={!searchValue}
            >
                <Icon k="search" />
            </button>
        </form>
    );
};

export default SearchForm;
